"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var MailMagazineConsentInput = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("div", { className: "estimateForm-MailMagazineConsent" },
        react_1.default.createElement("input", { type: "hidden", name: store.name, value: "false" }),
        react_1.default.createElement("label", { className: "estimateForm-CheckboxInputOption" },
            react_1.default.createElement("input", { type: "checkbox", onChange: store.handleChange, name: store.name, value: "true", checked: store.checked, className: "estimateForm-CheckboxInputOption_Input" }),
            react_1.default.createElement("span", { className: "estimateForm-CheckboxInputOption_Label" }, store.label))));
});
exports.default = MailMagazineConsentInput;
